//
const contactEmailAdress = "abdouabarchia@gmail.com";
//
const contactWhatsAppNumber = "+227 86 16 55 58";
//
const contactPhoneNumber = "+227 86 16 55 58";
//
const contactAddress = "Niger, Niamey";
//
const programmintLanguageNumber = "3";
//
const professionalExperienceYears = `${
  new Date().getFullYear() - new Date("2021").getFullYear()
}`;
//
const projectCompleted = "9";
//
const clientNumber = "+2";
//
const professionalExperience = `+${
  new Date().getFullYear() - new Date("2021").getFullYear()
}`;
//
export {
  contactEmailAdress,
  contactWhatsAppNumber,
  contactPhoneNumber,
  contactAddress,
  programmintLanguageNumber,
  professionalExperienceYears,
  projectCompleted,
  professionalExperience,
  clientNumber,
};
